import { useApiQuery } from '../../api/useApi';

/**
 * Combien de catalogues cet établissement a-t-il ? — #40, #87.
 *
 * Sert l'unique prédicat d'éligibilité de l'écran « Commandes » — voir
 * `domain/ecranCommandes.ts`, qui porte la règle et sa raison.
 *
 * Hook maison plutôt que `pages/products/api/useCatalogs` : la frontière du socle
 * (#23) interdit d'atteindre `pages/`, et celui-là rend une page complète de
 * catalogues alors qu'on ne veut qu'un **compte**.
 *
 * ⚠️ Il est appelé au démarrage, pour tous les comptes, et son résultat décide
 * d'une entrée de menu : `per_page=1` suffit, seul `meta.total` est lu.
 */
interface PageCatalogues {
    meta?: { total?: number };
}

export function useNombreDeCatalogues(facilityId: number | null) {
    const query = useApiQuery<PageCatalogues>(
        facilityId ? `/catalogs?per_page=1&facility_id=${facilityId}` : '',
        {},
        {
            enabled: facilityId !== null,
            // L'équipement d'un hôtel ne change pas en cours de session : inutile
            // de le redemander à chaque retour sur l'app.
            staleTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
        },
    );

    return query.data?.meta?.total;
}
